import { render, staticRenderFns } from "./GroupDealGeneral.vue?vue&type=template&id=68a1a69d"
import script from "./GroupDealGeneral.vue?vue&type=script&lang=js"
export * from "./GroupDealGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports